/**
 * @generated SignedSource<<42f037c9e91cb9a2b91bfdd2a8801959>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getShoppablePhotoData_creators$data = {
  readonly photoCreatorItems: ReadonlyArray<{
    readonly serviceId: string | null;
  } | null> | null;
  readonly " $fragmentType": "getShoppablePhotoData_creators";
};
export type getShoppablePhotoData_creators$key = {
  readonly " $data"?: getShoppablePhotoData_creators$data;
  readonly " $fragmentSpreads": FragmentRefs<"getShoppablePhotoData_creators">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "getShoppablePhotoData_creators"
};

(node as any).hash = "87d4964b0057a3e347588d11ed54702a";

export default node;
